<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.4286 17.7637C27.4286 20.4404 26.4889 23.0343 24.7696 25.1034C23.0502 27.1725 20.6577 28.5888 17.9996 29.111C15.3415 29.6332 12.5824 29.229 10.1922 27.9672C7.80206 26.7054 5.92883 24.6641 4.8917 22.1912C3.85457 19.7182 3.7177 16.9666 4.50442 14.4052C5.29113 11.8437 6.95276 9.63095 9.20618 8.14386C11.4596 6.65676 14.1654 5.98737 16.8625 6.24973C19.5596 6.51209 21.9979 7.59142 23.9143 9.48413M23.9143 9.48413L16.3651 11.5016M23.9143 9.48413L21.9619 2"
      stroke="white" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>
